import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import rehypeSlug from 'rehype-slug';
import 'highlight.js/styles/github-dark.css';

const useStyles = makeStyles((theme) => ({
  content: {
    '& pre': {
      borderRadius: '8px',
      padding: theme.spacing(2),
      overflow: 'auto',
    },
    '& code:not(pre code)': {
      backgroundColor: theme.palette.action.hover,
      borderRadius: '4px',
      padding: '2px 6px',
      fontSize: '0.875em',
    },
    '& a': {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '& blockquote': {
      borderLeft: `4px solid ${theme.palette.secondary.main}`,
      margin: `${theme.spacing(2)} 0`,
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      color: theme.palette.text.secondary,
    },
    '& img': {
      maxWidth: '100%',
      borderRadius: '8px',
    },
    '& ul, & ol': {
      paddingLeft: theme.spacing(3),
    },
    '& li': {
      marginBottom: theme.spacing(0.5),
    },
  },
}));

const headingMap = {
  h1: (props) => <Typography variant="h3" gutterBottom {...props} />,
  h2: (props) => (
    <Typography variant="h4" gutterBottom sx={{ mt: 4 }} {...props} />
  ),
  h3: (props) => (
    <Typography variant="h5" gutterBottom sx={{ mt: 3 }} {...props} />
  ),
  h4: (props) => (
    <Typography variant="h6" gutterBottom sx={{ mt: 2 }} {...props} />
  ),
  p: (props) => <Typography variant="body1" paragraph {...props} />,
};

const MarkdownContent = ({ body }) => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight, rehypeSlug]}
        components={headingMap}
      >
        {body}
      </Markdown>
    </div>
  );
};

export default MarkdownContent;
